import { Navigate, useLocation } from "react-router-dom";

// Old document URLs → new sections (tab names mapped where they changed)
const TAB_MAP = { "/onboarding-documents": { documents: "/marksman-documents?tab=corporate", company: "/marksman-documents?tab=company", forms: "/client-onboarding?tab=forms" } };

export const Redirect = ({ to }) => {
  const { pathname, search } = useLocation();
  const tab = new URLSearchParams(search).get("tab");
  const mapped = TAB_MAP[pathname]?.[tab];
  return <Navigate to={mapped || to} replace />;
};
